import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { PaginationSelectComponent } from '@components/pagination-select/pagination-select.component';
import {
  IconoirFastArrowLeft,
  IconoirFastArrowRight,
  IconoirNavArrowLeft,
  IconoirNavArrowRight,
} from '@ey-xd/motif-icon';
import { ButtonSizes, MotifButtonModule, MotifIconModule, MotifPaginationModule } from '@ey-xd/ng-motif';
import { Option } from '@ey-xd/ng-motif/lib/pagination/pagination-select/pagination-select.interface';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  standalone: true,
  imports: [MotifPaginationModule, PaginationSelectComponent, TranslatePipe, MotifButtonModule, MotifIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationComponent {
  currentPage = input.required<number>();
  numberOfPages = input.required<number>();
  numberOfRows = input.required<number>();
  pageSizeOptions = input.required<Option[]>();
  currentPageSize = input.required<Option>();
  pageChanged = output<number>();
  pageSizeChanged = output<Option>();
  buttonSize = ButtonSizes;

  goToFirstPage(): void {
    this.pageChanged.emit(1);
  }

  goToPreviousPage(): void {
    if (this.currentPage() > 1) {
      this.pageChanged.emit(this.currentPage() - 1);
    }
  }

  goToNextPage(): void {
    if (this.currentPage() < this.numberOfPages()) {
      this.pageChanged.emit(this.currentPage() + 1);
    }
  }

  goToLastPage(): void {
    this.pageChanged.emit(this.numberOfPages());
  }

  onPageSizeChange(newPageSize: Option): void {
    this.pageSizeChanged.emit(newPageSize);
  }

  readonly IconoirFastArrowLeft = IconoirFastArrowLeft;
  readonly IconoirNavArrowLeft = IconoirNavArrowLeft;
  readonly IconoirFastArrowRight = IconoirFastArrowRight;
  readonly IconoirNavArrowRight = IconoirNavArrowRight;

  showFirstButtons = computed(() => this.currentPage() !== 1 && this.numberOfPages() > 1);
  showLastButtons = computed(() => this.currentPage() !== this.numberOfPages() && this.numberOfPages() > 1);
}
